// Override Settings
var boostPFSInstantSearchConfig = {
    search: {
        //suggestionMode: 'test',
        //suggestionPosition: 'left'
    }
};
(function() {
    BoostPFS.inject(this);
    // Customize style of Suggestion box
    SearchInput.prototype.customizeInstantSearch = function() {
        var suggestionElement = this.$uiMenuElement;
        var searchElement = this.$element;
        var searchBoxId = this.id;
    };
    // Start Boost 173810
    InstantSearchResultItemProduct.prototype.compileSuggestionProductPrice = function() {
        this.prepareSuggestionProductPriceData();
        // console.log('data', this?.data?.tags);
        // Check on sale
        var onSale = this.data.compare_at_price_min > this.data.price_min;
        // Format price
        var price = Utils.formatMoney(this.data.price_min, Globals.moneyFormat, true);
        var compareAtPrice = "";
        if (this.data && this.data.compare_at_price_min && this.data.compare_at_price_min > this.data.price_min) {
            compareAtPrice = Utils.formatMoney(this.data.compare_at_price_min, Globals.moneyFormat, true);
            if (Settings.getSettingValue("search.removePriceDecimal")) {
                price = Utils.removeDecimal(price);
                compareAtPrice = Utils.removeDecimal(compareAtPrice);
            }
        }
        //custom work
        // Calculate discounted price
        let formattedDiscountedPrice = '';
        let discountPercentage = '';
        let isDiscountEnable = 'no_discount_enable';
        const notInSale = this?.data?.tags?.includes('not-in-sale')
		const soldOut = this?.data?.tags?.includes('au-prd-draft') ? " sold_out_prd" : ""

        if (document.querySelector('body[discount_enabled]') || document.querySelector('body[product_discount_enabled]') || document.querySelector('[specific_product_off_discount]')) {
            const discountPercentageEl = document.querySelector('body[discount_enabled]')?.getAttribute('discount_enabled') || document.querySelector('body[product_discount_enabled]')?.getAttribute('product_discount_enabled') || 0;
            const matchingTags = this.data?.tags.filter(tag => tag.includes(document.querySelector('[specific_product_off_discount]') ? 'pdc-' : 'bfs-')).reduce((uniqueTags, tag) => {
                if (!uniqueTags.includes(tag)) uniqueTags.push(tag);
                return uniqueTags;
            }, []);
            const discountPercentageAmount = matchingTags[0]?.split('-')[1] || discountPercentageEl
            if (discountPercentageAmount > 0) {
                let discountPer = (100 - discountPercentageAmount) / 100;
                if (notInSale) {
                    discountPer = 1; // No discount applied
                }
                let discountedPrice = this.data.price_min * discountPer;
            // console.log("discountedPrice",this.data.price_min)
                formattedDiscountedPrice = Utils.formatMoney(discountedPrice, Globals.moneyFormat, true);
                isDiscountEnable = 'yes_discount_enable'
                if (Settings.getSettingValue("search.removePriceDecimal")) {
                    formattedDiscountedPrice = Utils.removeDecimal(formattedDiscountedPrice);
                }
                // Calculate discount percentage using compareAtPrice if available, otherwise use price
                let basePrice = this.data?.variants[0]?.compare_at_price > this.data?.variants[0]?.price ? this.data?.variants[0]?.compare_at_price : this.data?.variants[0]?.price;
                discountPercentage = ((basePrice - discountedPrice) / basePrice * 100).toFixed(0) + '%';
                discountPercentage = discountPercentage.replace('.00', '')
            }
        }


        // When no custom discount is active but product has a compare_at_price, use first variant's compare price layout
        if (!formattedDiscountedPrice && onSale) {
            let firstVariant = this.data?.variants?.[0];
            if (firstVariant?.compare_at_price && firstVariant.compare_at_price > firstVariant.price) {
                // Use ratio from first variant to derive prices from price_min (which is already normalized)
                let ratio = firstVariant.compare_at_price / firstVariant.price;
                let actualPrice = this.data.price_min;
                let derivedCompare = actualPrice * ratio;
                formattedDiscountedPrice = Utils.formatMoney(actualPrice, Globals.moneyFormat, true);
                compareAtPrice = Utils.formatMoney(derivedCompare, Globals.moneyFormat, true);
                if (Settings.getSettingValue("search.removePriceDecimal")) {
                    formattedDiscountedPrice = Utils.removeDecimal(formattedDiscountedPrice);
                    compareAtPrice = Utils.removeDecimal(compareAtPrice);
                }
                discountPercentage = ((1 - 1 / ratio) * 100).toFixed(0) + '%';
                isDiscountEnable = 'yes_discount_enable';
            }
        }

        
        // Build Price
        var result = "";
        if (Settings.getSettingValue("search.showSuggestionProductPrice")) {
            if (onSale && Settings.getSettingValue("search.showSuggestionProductSalePrice")) {
                result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE_SALE);
            } else {
                result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE);
            }
        }
        var priceVaries = this.data.price_min != this.data.price_max; // Check a product has many prices
        if (priceVaries) {
            price = "From " + price;
        }
        // setTimeout(() => {
        //     document.querySelectorAll('.boost-pfs-search-suggestion-product-regular-price')?.forEach(elm => {
        //         const pE = elm?.closest('.yes_discount_enable[discountpercentage]')?.querySelector('.instant_search_discounted_price');
        //         if (pE) pE.innerText = calculateReturnAmount(elm.innerText, parseInt(elm.closest('[discountpercentage]').getAttribute('discountpercentage')))
        //     })
        // }, 100);
        // custom work
        if (formattedDiscountedPrice) {
            return result
                .replace(/{{regularPrice}}/g, compareAtPrice ? compareAtPrice : price)
                .replace(/{{isDiscountEnable}}/g, isDiscountEnable)
                .replace(/{{discountedPrice}}/g, formattedDiscountedPrice)
                .replace(/{{soldOut}}/g, soldOut)
                .replace(/{{discountPercentage}}/g, discountPercentage);
        } else {
            return result
                .replace(/{{regularPrice}}/g, price)
                .replace(/{{compareAtPrice}}/g, compareAtPrice)
                .replace(/{{isDiscountEnable}}/g, isDiscountEnable)
                .replace(/{{discountedPrice}}/g, formattedDiscountedPrice)
                .replace(/{{soldOut}}/g, soldOut)
                .replace(/{{discountPercentage}}/g, discountPercentage);
        }
    };
    // End Boost 173810
    // Start Boost 174866
    InstantSearchOnclick.getOnClickData = function() {
        //   console.log('check')	
        setTimeout(() => testSearchKeywordsFn(), 0);
        var settings = Settings.getSettingValue('search.searchBoxOnclick');
        // Get from cache
        if (onClickData) {
            onClickData.recent_searches = InstantSearchOnclick.getOnClickRecentSearches();
            return onClickData;
        }
        // Get blocks
        var onClickBlocks = [];
        if (Settings.getSettingValue('search.searchBoxOnclick.recentSearch.status')) {
            onClickBlocks.push({
                key: InstantSearchEnum.ResultType.RECENT_SEARCHES,
                values: InstantSearchOnclick.getOnClickRecentSearches()
            });
        }
        if (Settings.getSettingValue('search.searchBoxOnclick.searchTermSuggestion.status')) {
            if (Array.isArray(InstantSearchNoResult.getNoResultData().no_result_suggestions) && InstantSearchNoResult.getNoResultData().no_result_suggestions.length > 0) {
                onClickBlocks.push({
                    key: InstantSearchEnum.ResultType.DEFAULT_SUGGESTIONS,
                    values: InstantSearchNoResult.getNoResultData().no_result_suggestions
                });
            } else {
                // console.log('1')
                onClickBlocks.push({
                    key: InstantSearchEnum.ResultType.DEFAULT_SUGGESTIONS,
                    values: Array.isArray(settings.searchTermSuggestion.data) ? settings.searchTermSuggestion.data : []
                });
            }
        }
        if (Settings.getSettingValue('search.searchBoxOnclick.productSuggestion.status')) {
            // Get products from async call to API
            InstantSearchOnclick.getOnClickProducts(settings.productSuggestion.data);
        }
        // console.log(onClickBlocks);
        // Set cache
        onClickData = onClickBlocks;
        return onClickData;
    }
    InstantSearchOnclick.getOnClickProducts = function(productIds) {
    	if (!Array.isArray(productIds) || productIds.length == 0) return;
    
    	var params = new URLSearchParams();
    	params.append('shop', Globals.shopDomain);
    	productIds.forEach(id => params.append('ids', id));
    	var queryString = params.toString();
    
    	jQ.ajax({
    		method: 'GET',
    		url: Api.getApiUrl('products') + '?' + queryString,
    		dataType: 'json',
    		success: (data) => {
    			onClickData.push({
    				key: InstantSearchEnum.ResultType.DEFAULT_PRODUCTS,
    				values: data
    			})
    		}
    	})
    }
    var onClickData = null;
    // End Boost 174866
    InstantSearchResultItemProduct.prototype.getTemplate = function(tempType) {
        // console.log('tempType: ', tempType, this)
        switch (tempType) {
            case InstantSearchResultItemProduct.tempType.IMAGE:
                return `
					<div class="{{class.searchSuggestion}}-left">
						<img tabindex="-1" src="{{imageUrl}}" alt="{{escapedTitle}}">
					</div>
				`.trim();
            case InstantSearchResultItemProduct.tempType.SKU:
                return `
					<p class="{{class.searchSuggestion}}-product-sku">SKU: {{sku}}</p>
				`.trim();
            case InstantSearchResultItemProduct.tempType.VENDOR:
                return `
					<p class="{{class.searchSuggestion}}-product-vendor">{{vendor}}</p>
				`.trim();
            case InstantSearchResultItemProduct.tempType.PRICE:
                return `
					<p class="{{class.searchSuggestion}}-product-price {{isDiscountEnable}} {{soldOut}}" discountPercentage={{discountPercentage}}>
						<span class="{{class.searchSuggestion}}-product-regular-price">{{regularPrice}}</span>
						<span class="instant_search_discounted_price">{{discountedPrice}}</span>
					</p>
				`.trim();
            case InstantSearchResultItemProduct.tempType.PRICE_SALE:
                return `
					<p class="{{class.searchSuggestion}}-product-price">
            <span class="{{class.searchSuggestion}}-product-sale-price">{{regularPrice}}</span>&nbsp;
						<s>{{compareAtPrice}}</s>
					</p>
				`.trim();
            default:
                return `
					<li class="boost-pfs-isw__tag-labels {{class.searchSuggestionItem}} {{class.searchSuggestionItem}}-product {{class.searchUiAutocompleteItem}}" aria-label="{{escapedBlockType}}: {{escapedTitle}}" data-id="{{id}}" role="option">
                        <div class="boost-pfs-filter-product-item-label">${buildTagLabels(this.data, false)}</div>
						<a tabindex="-1" href="{{url}}" {{newTabAttribute}}>
							{{itemProductImage}}
							<div class="{{class.searchSuggestion}}-right">
								<p class="{{class.searchSuggestion}}-product-title">{{title}}</p>
								{{itemProductSku}}
								{{itemProductVendor}}
								{{itemProductPrice}}
							</div>
						</a>
					</li>
				`.trim();
        }
    }
    // BUILD LABEL PRODUCT WITH TAGS
    function buildTagLabels(data, showall) {
        var tagLabelHtml = '<span class="tag boost-pfs-filter-label {{labelTag}}" >{{labelTag}}</span>';
        if (showall) {
            var tagLabel = '';
            if (data.tags) {
                for (var i = 0; i < data.tags.length; i++) {
                    var tag = data.tags[i];
                    if (tag.indexOf("pfs:label") !== -1) {
                        var preTagLabel = tagLabelHtml.replace(/{{labelTag}}/g, tag.split('pfs:label-')[1]);
                        tagLabel += preTagLabel;
                    }
                }
            }
        } else {
            var tagLabel = '';
            if (data.tags) {
                for (var i = data.tags.length - 1; i >= 0; i--) {
                    tag = data.tags[i];
                    if (tag.indexOf("pfs:label") !== -1) {
                        var preTagLabel = tagLabelHtml.replace(/{{labelTag}}/g, tag.split('pfs:label-')[1]);
                        tagLabel += preTagLabel;
                        break;
                    }
                }
            }
        }
        // console.log(tagLabel)
        return tagLabel;
    }
   InstantSearchApi.beforeCall = function(searchTerm) {
   Globals.instantSearchQueryParams.return_all_currency_fields = false;
   }
})();
const testSearchKeywords = ["", "Non-iron shirts", "Necktie", "Polos", "Knitted Ties", "Skinny Ties", "Bow Ties", "Socks", "Pocket Squares", "Cuff Links"];
const testSearchKeywordsHandle = ["", "/collections/shirts", "/collections/neckties", "/collections/polo-shirts", "/collections/knitted-ties", "/collections/skinny-ties", "/collections/bow-tie", "/collections/socks", "/collections/pocket-squares", "/collections/cufflinks"];
const testSearchKeywordsFn = () => {
    document.querySelectorAll('.boost-pfs-search-suggestion-group[data-group="default_suggestions"] ul li')?.forEach((elm, i) => {
        if (i > 0 && elm.querySelector('a')) {
            if (testSearchKeywordsHandle[i]) {
                elm.querySelector('a').setAttribute('href', testSearchKeywordsHandle[i]);
                elm.querySelector('a').innerText = testSearchKeywords[i];
            } else {
                elm.remove();
            }
        }
    });
};